import { isDefined } from "@clipboard-health/util-ts";
import { differenceInMinutes } from "date-fns";

interface GetArrivalTimeAwareMaxEtaIncrementParams {
  targetArrivalTime?: Date;
  shiftStartDate: Date;
  defaultMaxIncrement: number;
}

const ADDITIONAL_ETA_INCREMENT_MINUTES = 30;

/**
 * Returns the maximum increment for the ETA based on the target arrival time and shift start date.
 * This defines the max date that is available for the worker when they are updating their ETA.
 * Default logic for shifts with no arrival time is 60 minutes.
 * When there is an arrival time, we want to give the worker the option to update their ETA up to 30 minutes after the target arrival time.
 * Or the default max increment if it's greater.
 */
export function getArrivalTimeAwareMaxEtaIncrement({
  targetArrivalTime,
  shiftStartDate,
  defaultMaxIncrement,
}: GetArrivalTimeAwareMaxEtaIncrementParams) {
  if (!isDefined(targetArrivalTime)) {
    return defaultMaxIncrement;
  }

  const targetArrivalTimeMaxIncrement =
    differenceInMinutes(targetArrivalTime, shiftStartDate) + ADDITIONAL_ETA_INCREMENT_MINUTES;

  return Math.max(targetArrivalTimeMaxIncrement, defaultMaxIncrement);
}
